// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6032":"d3d8a79d","7136":"8b1e8801"}[chunkId] + ".chunk.css";
};